import { useCallback } from 'react'

const publisherTOSURLS = {
    Meta: (account_id) => `https://business.facebook.com/ads/manage/customaudiences/tos/?act=${account_id}`,
}

const objectToQuery = (object) => {
    return new URLSearchParams(object).toString()
}

const popupHeight = 700
const popupWidth = 800

export const useTOSacceptance = (props) => {
    const showTOS = useCallback(
        (account_id, publisher = 'Meta') => {
            const left = window.screenX + (window.outerWidth - popupWidth) / 2
            const top = window.screenY + (window.outerHeight - popupHeight) / 2

           window.open(
                publisherTOSURLS[publisher](account_id).replace('act_', ''),
                'fb-oauth',
                [
                    `width=${popupWidth}`,
                    `height=${popupHeight}`,
                    `top=${top}`,
                    `left=${left}`,
                    'toolbar=no',
                    'menubar=no',
                    'status=no',
                    'location=no', // disables location bar in some browsers
                ].join(','),
            )
        },
        [props],
    )

    return { showTOS }
}
